// export const internalRoles = ["admin", "doctor", "staff", "owner"];
export const internalRoles = ["internal"];
export const adminOnlyRoles = ["admin", "owner", "manager", "doctor"];

export const dashboardUserRoles = ["admin", "staff", "doctor"];
export const ultrasoundUserRoles = ["admin", "staff", "doctor"];

export const appointmentCreators = ["doctor", "staff"];

export const transactionTables = [""];

export const canEditForms = ["admin", "doctor"];
